import {apiCredential} from "../../../../libraries/api-credential";
import {ContentType} from "ct-library-api-credential";
import {
  FetchQueueStatusRequest,
  FetchQueueStatusResponse,
  RegisterWaitingQueueRequest,
  RegisterWaitingQueueResponse,
} from "../types/waitingQueue.types";

export const WaitingQueueAPI = {
  fetchQueueStatus: async (
    _request: FetchQueueStatusRequest,
  ): Promise<FetchQueueStatusResponse> => {
    try {
      const response = await apiCredential.call<FetchQueueStatusResponse>({
        path: "/api/v1/queues/status",
        method: "GET",
        format: "json",
        type: ContentType.Json,
        credentials: "include",
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  registerWaitingQueue: async (
    _request: RegisterWaitingQueueRequest,
  ): Promise<RegisterWaitingQueueResponse> => {
    try {
      const response = await apiCredential.call<RegisterWaitingQueueResponse>({
        path: "/api/v1/queues/enter",
        method: "POST",
        format: "json",
        type: ContentType.Json,
        credentials: "include",
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
